import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { getDegreeOfferingList } from '../../../utils/degree-offerings';
import ListDataPod from '../../../components/ListDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.profiles.degrees-offered.title',
    defaultMessage: 'Degrees Offered',
  },
  description: {
    id: 'hubs.profiles.degrees-offered.description',
    defaultMessage: 'Online programs available',
  },
});

function DegreesOffered({ majors, intl, lastUpdated, programsOnline }) {
  const list = getDegreeOfferingList(majors);

  return list.length ? (
    <ListDataPod
      header={intl.formatMessage(messages.title)}
      footer={lastUpdated}
      content={{
        list,
        info: programsOnline ? intl.formatMessage(messages.description) : null,
      }}
      className="very-dark-gray"
    />
  ) : null;
}

export default injectIntl(DegreesOffered);

DegreesOffered.propTypes = {
  lastUpdated: PropTypes.string,
  majors: PropTypes.arrayOf(PropTypes.object),
  intl: PropTypes.object,
  programsOnline: PropTypes.bool,
};
